import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Avatar, LevelBadge } from "@/components/common";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard").then((r) => { setRows(r.data); setLoading(false); });
  }, []);

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Standing" title="Leaderboard"
        subtitle="Points earned by posting, commenting, receiving likes, and completing lessons." />
      {loading ? (
        <div className="text-center py-16 text-muted-foreground eyebrow">Loading…</div>
      ) : (
        <div className="border border-border bg-card rounded-xl divide-y divide-border">
          {rows.map((r) => (
            <Link key={r.user_id} to={`/members/${r.user_id}`}
              data-testid={`leaderboard-row-${r.user_id}`}
              className="flex items-center gap-4 px-4 sm:px-6 py-4 hover:bg-secondary/40 transition-colors">
              <div className={`w-8 text-center font-serif text-2xl ${r.rank <= 3 ? "text-gold" : "text-muted-foreground"}`}>
                {r.rank}
              </div>
              <Avatar src={r.picture} name={r.name} size={44} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm">{r.name}</span>
                  {r.rank === 1 && <Trophy size={14} className="text-gold" />}
                </div>
                <div className="mt-1"><LevelBadge level={r.level} /></div>
              </div>
              <div className="text-right">
                <div className="font-mono text-lg">{r.points.toLocaleString()}</div>
                <div className="eyebrow text-muted-foreground">points</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
